import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


const router = new Router({
    mode: 'hash',
    routes: [
        {path: '/', redirect: '/member/index'},
        {
            path: '/login', meta: {title: 'member'},
            component: r => require.ensure([], () => r(require('../views/Login'), 'login'))
        },
        {
            path: '/company_auth', meta: {title: '企业认证'},
            component: r => require.ensure([], () => r(require('@/views/CompanyAuth'), 'company_auth'))
        }, {
            path: '/login', meta: {title: '登录', noAuth: true},
            component: r => require.ensure([], () => r(require('@/views/Login'), 'login'))
        }, {
            path: '/register', meta: {title: '注册', noAuth: true},
            component: r => require.ensure([], () => r(require('@/views/Register'), 'register'))
        }, {
            path: '/register_success', meta: {title: '注册成功', noAuth: true},
            component: r => require.ensure([], () => r(require('@/views/RegisterSucc'), 'register'))
        }, {
            path: '/pwd_reset', meta: {title: '修改密码', noAuth: true},
            component: r => require.ensure([], () => r(require('@/views/PwdReset'), 'pwd'))
        }, {
            path: '/pwd_reset_success', meta: {title: '修改密码成功', noAuth: true},
            component: r => require.ensure([], () => r(require('@/views/PwdResetSucc'), 'pwd'))
        }, {
            path: '/auth_success', meta: {title: '认证提交成功', noAuth: true},
            component: r => require.ensure([], () => r(require('@/views/AuthSuccess'), 'auth'))
        },
        // member 会员中心
        {
            path: '/member/',
            component: r => require.ensure([], () => r(require('@/views/member/Default'), 'member')),
            redirect: '/member/index',
            meta: {noAuth: true},
            children: [
                {
                    path: 'index', meta: {title: '会员中心'},
                    component: r => require.ensure([], () => r(require('@/views/member/Index'), 'member'))
                }, {
                    path: 'order/flash', meta: {title: '内存测试订单'},
                    component: r => require.ensure([], () => r(require('@/views/member/order/FlashOrder'), 'member'))
                }, {
                    path: 'order/ssd', meta: {title: '存储产品订单'},
                    component: r => require.ensure([], () => r(require('@/views/member/order/SsdOrder'), 'member'))
                }, {
                    path: 'info', meta: {title: '账户信息'},
                    component: r => require.ensure([], () => r(require('@/views/member/Information'), 'member'))
                }, {
                    path: 'info/mobile/step1', mate: {title: '修改手机号'},
                    component: r => require.ensure([], () => r(require('@/views/member/mobile/AlterMobile1'), 'member'))
                }, {
                    path: 'info/mobile/step2', meta: {title: '修改手机号'},
                    component: r => require.ensure([], () => r(require('@/views/member/mobile/AlterMobile2'), 'member'))
                }, {
                    path: 'info/mobile/success', meta: {title: '修改手机号'},
                    component: r => require.ensure([], () => r(require('@/views/member/mobile/AlterMobileSucc'), 'member'))
                }, {
                    path: 'alter_pwd', meta: {title: '修改密码'},
                    component: r => require.ensure([], () => r(require('@/views/member/pwd/AlterPwd'), 'member'))
                }, {
                    path: 'my_complaint', meta: {title: '我的建议'},
                    component: r => require.ensure([], () => r(require('@/views/member/MyComplaint'), 'member'))
                }, {
                    path: 'addr_info', meta: {title: '收/取货信息'},
                    component: r => require.ensure([], () => r(require('@/views/member/AddrInfo'), 'member'))
                }, {
                    path: 'wallet', meta: {title: '钱包账户管理'},
                    component: r => require.ensure([], () => r(require('@/views/member/wallet/Wallet'), 'member'))
                }, {
                    path: 'wallet/step1', meta: {title: '钱包账户管理-开通'},
                    component: r => require.ensure([], () => r(require('@/views/member/wallet/Open1'), 'member'))
                }, {
                    path: 'wallet/step2', meta: {title: '钱包账户管理-开通'},
                    component: r => require.ensure([], () => r(require('@/views/member/wallet/Open2'), 'member'))
                }, {
                    path: 'wallet/step3', meta: {title: '钱包账户管理-开通'},
                    component: r => require.ensure([], () => r(require('@/views/member/wallet/Open3'), 'member'))
                }, {
                    path: 'wallet/success', meta: {title: '钱包账户管理-开通'},
                    component: r => require.ensure([], () => r(require('@/views/member/wallet/OpenSucc'), 'member'))
                }, {
                    path: 'wallet/withdraw1', meta: {title: '钱包账户管理-提现'},
                    component: r => require.ensure([], () => r(require('@/views/member/withdraw/Withdraw1'), 'member'))
                }, {
                    path: 'wallet/withdraw2', meta: {title: '钱包账户管理-提现'},
                    component: r => require.ensure([], () => r(require('@/views/member/withdraw/Withdraw2'), 'member'))
                }, {
                    path: 'wallet/withdraw3', meta: {title: '钱包账户管理-提现'},
                    component: r => require.ensure([], () => r(require('@/views/member/withdraw/WithdrawSucc'), 'member'))
                }, {
                    path: 'recharge', meta: {title: '钱包账户管理-充值'},
                    component: r => require.ensure([], () => r(require('@/views/member/recharge/Recharge'), 'member'))
                }, {
                    path: 'recharge/success', meta: {title: '钱包账户管理-充值'},
                    component: r => require.ensure([], () => r(require('@/views/member/recharge/RechargeSucc'), 'member'))
                }, {
                    path: 'wallet/alter_account_success', meta: {title: '钱包账户管理-修改提现账户'},
                    component: r => require.ensure([], () => r(require('@/views/member/wallet/AlterAccountSucc'), 'member'))
                }, {
                    path: 'pwd', meta: {title: '支付密码管理'},
                    component: r => require.ensure([], () => r(require('@/views/member/pwd/Pwd'), 'member'))
                }, {
                    path: 'pwd/alter1', meta: {title: '支付密码管理-修改支付密码'},
                    component: r => require.ensure([], () => r(require('@/views/member/pwd/PwdAlter1'), 'member'))
                }, {
                    path: 'pwd/alter2', meta: {title: '支付密码管理-修改支付密码'},
                    component: r => require.ensure([], () => r(require('@/views/member/pwd/PwdAlter2'), 'member'))
                }, {
                    path: 'pwd/reset', meta: {title: '支付密码管理-重置支付密码'},
                    component: r => require.ensure([], () => r(require('@/views/member/pwd/PwdReset'), 'member'))
                }, {
                    path: 'pwd/success', meta: {title: '支付密码管理-修改成功'},
                    component: r => require.ensure([], () => r(require('@/views/member/pwd/PwdSucc'), 'member'))
                }, {
                    path: 'record', meta: {title: '钱包明细记录-充值记录'},
                    component: r => require.ensure([], () => r(require('@/views/member/recharge/RechargeRecord'), 'member'))
                }, {
                    path: 'news', meta: {title: '我的消息'},
                    component: r => require.ensure([], () => r(require('@/views/member/News'), 'member'))
                }, {
                    path: 'announce', meta: {title: '领存公告'},
                    component: r => require.ensure([], () => r(require('@/views/member/Announce'), 'member'))
                }, {
                    path: 'quotation', meta: {title: '我的报价单'},
                    component: r => require.ensure([], () => r(require('@/views/member/Quotation'), 'member'))
                }, {
                    path: 'invoice', meta: {title: '发票管理'},
                    component: r => require.ensure([], () => r(require('@/views/member/invoice/invoice'), 'member'))
                }, {
                    path: 'purchase/invitation', meta: {title: '采购信息列表'},
                    component: r => require.ensure([], () => r(require('@/views/member/purchase/Invitation'), 'member'))
                }, {
                    path: 'purchase/detail', meta: {title: '采购详情'},
                    component: r => require.ensure([], () => r(require('@/views/member/purchase/Detail'), 'member'))
                }, {
                    path: 'purchase/quotation', meta: {title: '采购报价单'},
                    component: r => require.ensure([], () => r(require('@/views/member/purchase/Quotation'), 'member'))
                }, {
                    path: 'purchase/PurchaseAdsList', meta: {title: '采购公告'},
                    component: r => require.ensure([], () => r(require('@/views/member/purchase/PurchaseAdsList'), 'member'))
                }
            ]
        },
        {
            path: '/help', meta: {title: '帮助中心', noAuth: true},
            component: r => require.ensure([], () => r(require('@/views/Help'), 'help'))
        }, {
            path: '/invest_our', meta: {title: '投资领存', noAuth: true},
            component: r => require.ensure([], () => r(require('../views/invest/InvestOur'), 'investor'))
        }, {
            path: '/quest_our_invest', meta: {title: '寻求领存投资', noAuth: true},
            component: r => require.ensure([], () => r(require('../views/invest/QuestOurInvestor'), 'investor'))
        },
        {
            path: '/pdf', meta: {title: '寻求领存投资', noAuth: true},
            component: r => require.ensure([], () => r(require('../views/invest/Pdf'), 'pdf'))
        },
        {
            path: '/investor', meta: {title: '投资关系', noAuth: true},
            component: r => require.ensure([], () => r(require('../views/invest/Investorform'), 'investor'))
        },
        {
            path: '/investor_succ', meta: {title: '投资关系', noAuth: true},
            component: r => require.ensure([], () => r(require('../views/invest/SubSuccess'), 'SubSuccess'))
        },
        {
            path: '/fpga', meta: {title: 'FPGA信号处理基板', noAuth: true},
            component: r => require.ensure([], () => r(require('../views/FPGA.vue'), 'fpga'))
        },
        {
            path: '/chips', meta: {title: '主控芯片', noAuth: true},
            component: r => require.ensure([], () => r(require('../views/Chips.vue'), 'chips'))
        },
        //购买产品
        {
            path: '/ssd/buy_product1', meta: {title: '购买产品-获取报价', noAuth: true},
            component: r => require.ensure([], () => r(require('../views/ssd/BuyProduct1'), 'ssd'))
        }, {
            path: '/ssd/buy_product2', meta: {title: '购买产品-提交订单', noAuth: true},
            component: r => require.ensure([], () => r(require('../views/ssd/BuyProduct2'), 'ssd'))
        }, {
            path: '/ssd/pay_error', meta: {title: '购买产品-支付异常', noAuth: true},
            component: r => require.ensure([], () => r(require('../views/ssd/PayError'), 'ssd'))
        }, {
            path: '/ssd/buy_product4', meta: {title: '购买产品-生产测试', noAuth: true},
            component: r => require.ensure([], () => r(require('../views/ssd/BuyProduct4'), 'ssd'))
        }, {
            path: '/ssd/buy_product6', meta: {title: '购买产品-领存收货', noAuth: true},
            component: r => require.ensure([], () => r(require('../views/ssd/BuyProduct6'), 'ssd'))
        }, {
            path: '/ssd/pay_success',
            meta: {title: '成功支付尾款', noAuth: true},
            component: r => require.ensure([], () => r(require('../views/ssd/PaySuccess'), 'ssd'))
        }, {
            path: '/ssd/order_pay', meta: {title: '钱包支付', noAuth: true}, component: r => {
                require.ensure([], () => r(require('../views/ssd/OrderPay'), 'ssd'))
            }
        }, {
            path: '/member/purchase/QuotedPrice', meta: {title: '报价详情'},
            component: r => require.ensure([], () => r(require('@/views/member/purchase/QuotedPrice'), 'member'))
        }

    ]
})
router.beforeEach((to, from, next) => {
    document.title = to.meta.title ? '领存官网-' + to.meta.title : '深圳市领存技术有限公司'
    if (to.matched.some(r => r.meta.requireAuth)) {
        if (store.state.token) {
            next()
        }
    } else {
        next()
    }
})
// 跳转后返回顶部
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0)
})

export default router
